import React from 'react';
import Grid from "@mui/material/Grid";
import { Button } from '@mui/material';
import FormModal from '../../../components/FormModal';
import AddCreditMemo from '../Forms/AddCreditMemo';
const CreditMemoPage = (props) => {
    const [data, setData] = React.useState(null);
    const [completed, setCompleted] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [edit, setEdit] = React.useState(false);
    const [reload, setReload] = React.useState(true);
    const handleClose = () => {
        setCompleted(false);
        setEdit(false);
        setData(null);
        setOpen(false);
    }


    const createPO = (ser) => () => {
        setOpen(true);
        setEdit(false);
        setData(null);
    }
    var title = "Create Credit Memo";
    if (edit) {
        title = "Edit Credit Memo";
    } else if (completed) {
        title = "View Credit Memo";
    }
    return (
        <React.Fragment>
            <FormModal open={open} handleClose={handleClose} title={title} >
                <AddCreditMemo data={data} access={props.access} reload={props.reloadFunc} handleClose={handleClose} edit={edit} completed={completed} />
            </FormModal>

            <Grid container spacing={3.5}>
                <Grid item xs={12}>
                    {props.createOne ? <Button onClick={createPO(false)} variant="contained" style={{ marginRight: '20px' }}>Create New Credit Memo</Button> : null}
                </Grid>
            </Grid>
        </React.Fragment >
    );
};


export default CreditMemoPage;
